"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _DownloadCSV = _interopRequireDefault(require("./DownloadCSV"));
var _Report = _interopRequireDefault(require("../../Code/Exports/Report"));
var _DownloadText = _interopRequireDefault(require("../../Code/Exports/DownloadText"));
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var elementIcons = {};
_cccisdLaravelFlow.allElements.forEach(function (element) {
  elementIcons[element.code] = element.icon;
});
var convertLoadedData = function convertLoadedData(tableColumReportHeaders) {
  return function (data) {
    var variableList = data.metrics.variableList.filter(function (variable) {
      return tableColumReportHeaders.includes(variable.reportHeader);
    });
    return _objectSpread(_objectSpread({}, data), {}, {
      metrics: {
        filteredCount: variableList.length,
        totalCount: variableList.length,
        variableList: variableList
      }
    });
  };
};
var tableActions = function tableActions(assignment, tableColumReportHeaders) {
  return [{
    name: 'exportCodebookCVS',
    action: /*#__PURE__*/_react["default"].createElement(_DownloadCSV["default"], {
      type: "SPS",
      renderTrigger: function renderTrigger(download) {
        return /*#__PURE__*/_react["default"].createElement("a", {
          onClick: download
        }, "Export Codebook as CSV");
      },
      assignment: assignment,
      surveyHandles: [],
      typeFilter: [],
      filter: [],
      limit: 5000,
      convertLoadedData: convertLoadedData(tableColumReportHeaders)
    })
  }, {
    name: 'exportCodebookSPSS',
    action: /*#__PURE__*/_react["default"].createElement(_DownloadText["default"], {
      type: "SPS",
      renderTrigger: function renderTrigger(download) {
        return /*#__PURE__*/_react["default"].createElement("a", {
          onClick: download
        }, "Export Codebook as SPSS");
      },
      assignment: assignment,
      surveyHandles: [],
      typeFilter: [],
      filter: [],
      limit: 5000,
      convertLoadedData: convertLoadedData(tableColumReportHeaders),
      doNotAllowEmptyDataDownload: false
    })
  }, {
    name: 'exportCodebookSAS',
    action: /*#__PURE__*/_react["default"].createElement(_DownloadText["default"], {
      type: "SAS",
      renderTrigger: function renderTrigger(download) {
        return /*#__PURE__*/_react["default"].createElement("a", {
          onClick: download
        }, "Export Codebook as SAS");
      },
      assignment: assignment,
      surveyHandles: [],
      typeFilter: [],
      filter: [],
      limit: 5000,
      convertLoadedData: convertLoadedData(tableColumReportHeaders),
      doNotAllowEmptyDataDownload: false
    })
  }, {
    name: 'exportCodebookPDF',
    action: /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      renderTrigger: function renderTrigger(modal) {
        return /*#__PURE__*/_react["default"].createElement("a", {
          onClick: modal.onClick
        }, "Export Codebook as PDF");
      },
      size: "large"
    }, /*#__PURE__*/_react["default"].createElement(_Report["default"], {
      assignment: assignment,
      surveyHandles: [],
      typeFilter: [],
      filter: [],
      limit: 5000,
      elementIcons: elementIcons,
      convertLoadedData: convertLoadedData(tableColumReportHeaders),
      doNotAllowEmptyDataDownload: false
    }))
  }];
};
var _default = exports["default"] = tableActions;